import { render } from "./CardFive.vue?vue&type=template&id=3634156c"
import script from "./CardFive.vue?vue&type=script&lang=js"
export * from "./CardFive.vue?vue&type=script&lang=js"

import "./CardFive.vue?vue&type=style&index=0&id=3634156c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__